@if (!dataLoaded) {
  <div>
    <div class="h6-text">Retrieving data ...</div>
  </div>
}
@if (dataLoaded && chartData[0].data!.length === 0) {
  <div>
    <div class="h6-text">Insufficient data available</div>
  </div>
}
@if (dataLoaded && chartData[0].data!.length > 0) {
  <div class="row">
    <div class="col-lg-4">
      <div class="chart-legend" style="max-width: 100%;overflow: auto;">
        <table class="table table-hover NWMtable">
          <thead>
            <tr>
              <th>Asset Class</th>
              <th class="text-right">Value</th>
              <th class="text-right">Allocation</th>
            </tr>
          </thead>
          <tbody>
            @for (pc of portfolioComposition; track pc) {
              <tr>
                <td>
                  @if (pc.Url && !isPershing) {
                    <a target="_blank" [href]="pc.Url">{{pc.AssetSubClass}}</a>
                  }
                  @if (!pc.Url || isPershing) {
                    <span>{{pc.AssetSubClass}}</span>
                  }
                </td>
                <td class="text-right">{{pc.MarketValue | number:'1.0-0' | minusSignToParens}}</td>
                <td class="text-right">{{pc.PercentInAssetSubClass}}</td>
              </tr>
            }
            <tr>
              <td class="donutTotal">Total</td>
              <td class="donutTotal text-right">{{total | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}</td>
              <td class="donutTotal text-right">100.00%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-lg-8">
      <div class="NWMchart m-0 pieChart responsive">
        <ng-container *ngTemplateOutlet="piechart" />
      </div>
      <div class="chart-legend" style="max-width: 100%;overflow: auto;">
        <table class="table table-hover NWMtable portfolioallocation"  [ngClass]="!plan ? 'assetDetail' : ''">
          <thead>
            <tr>
              <th style="width:180px">Sub-Asset Class</th>
              <th class="text-right">Value</th>
              <th class="text-right" style="width:95px">Allocation</th>
              <th class="text-right">Details</th>
              @if (!plan) {
                <th></th>
              }
              <th class="pieChartArea d-md-table-cell d-none"></th>
            </tr>
          </thead>
          <tbody>
            @for (pc of portfolioDetails; track pc; let i = $index) {
              <tr>
                <td>
                  @if (pc.Url && !isPershing) {
                    <a href="/resource/plannings">{{pc.AssetSubClass}}</a>
                  }
                  @if (!pc.Url || isPershing) {
                    <span>{{pc.AssetSubClass}}</span>
                  }
                </td>
                <td class="text-right">{{pc.MarketValue | number:'1.0-0' | minusSignToParens}}</td>
                <td class="text-right">{{pc.PercentInAssetSubClass}}</td>
                @if (!plan) {
                  <td class="text-right" data-toggle="modal" data-target="#assetModal" (click)="onAssetClick(pc.AssetSubClass, pc.MarketValue, pc.PercentInAssetSubClass, pc.Details)"><a class="viewassetdetail" href="javascript:void(0)">View</a></td>
                }
                <td class="share-bar">
                  <div>
                    <span [ngStyle]="{'backgroundColor': pc.ReportColor, 'width':(pc.percent * 100 / portfolioMaxPercent!)+'%'}"></span>
                  </div>
                </td>
                @if (i===0) {
                  <td class="pieChartArea d-md-table-cell d-none" style="min-height:260px;height:260px;" [attr.rowspan]="portfolioDetails!.length">
                    <div class="NWMchart m-0 pieChart inChart">
                      <ng-container *ngTemplateOutlet="piechart" />
                    </div>
                  </td>
                }
              </tr>
            }
            <tr class="usdExposure-tooltip">
              <td class="donutTotal">Total</td>
              <td class="donutTotal text-right">{{total | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}</td>
              <td class="donutTotal text-right">100.00%</td>
              <td class="donutTotal">&nbsp;</td>
              @if (!plan) {
                <td class="donutTotal">&nbsp;</td>
              }
              <td class="donutTotal pieChartArea d-md-table-cell d-none">&nbsp;</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
@if (usdExposure) {
  <div class="text-right">
    Total USD Exposure valued at {{usdExposure | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}, allocated at {{usdExposurePercentage | percent:'1.2-2' | minusSignToParens}}
  </div>
}


@if (!plan) {
  <div class="modal fade" id="assetModal" tabindex="-1" role="dialog" aria-labelledby="assetModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      @if (assetDetails) {
        <div class="modal-content">
          <div class="modal-header">
            <div class="h4-text modal-title text-center w-100" id="assetModalLabel">Sub Asset Class: {{ assetDetails.name }}</div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <table width="100%" class="table table-hover NWMtable">
                <tbody>
                  <tr>
                    <th>Investments</th>
                    <th class="text-right">Value</th>
                    <th class="text-right">Allocation</th>
                  </tr>
                  @for (asset of assetDetails.details; track asset) {
                    <tr>
                      <td>{{ asset.ProductName }}</td>
                      <td class="text-right">{{ (asset.amount | number:'1.0-0' | minusSignToParens) }}</td>
                      <td class="text-right">{{ asset.localpercent }}</td>
                    </tr>
                  }
                  <tr class="totals">
                    <td>Total</td>
                    <td class="text-right">{{ (assetDetails.total | number:'1.0-0' | minusSignToParens) }}</td>
                    <td class="text-right">{{ assetDetails.totalPercent }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}

<ng-template #piechart>
  <canvas width="250px" height="250px" baseChart
    style="max-width:250px;margin:18px 0 0 0"
    [type]     ="chartType"
    [options]  ="chartSettings.options"
    [datasets] ="chartData"
    [labels]   ="chartLabels"
    [legend]   ="chartLegend"
    (chartClick)="chartClicked($event)"
  ></canvas>
  @if (tooltip.visible) {
    <div class="NWMchart-tooltip">
      <table>
        @for (row of tooltip.rows; track row) {
          <tr class="{{row.class}}"><td class="pr-1">{{row.key}}</td><td class="tooltip-value">{{row.value}}</td></tr>
        }
      </table>
    </div>
  }
</ng-template>

